import { constants } from '@eti/utils';
import { vars } from '@etg/wings';

export const getChatbotOrianaAppearanceData = (brandCode: string) => {
  const { brands } = constants;

  if (brandCode === brands.GOTOGATE) {
    return {
      uiBundle: 'go_to_gate_ui_bundle',
      avatarFilename: 'avatar-gotogate.png',
      headerColor: vars.colors.decoration.dark,
    };
  }

  if (brandCode === brands.FLIGHTNETWORK) {
    return {
      uiBundle: 'flight_network_ui_bundle',
      avatarFilename: 'avatar-flightnetwork.png',
      headerColor: vars.colors.decoration.dark,
    };
  }

  if (brandCode === brands.MYTRIP) {
    return {
      uiBundle: 'my_trip_ui_bundle',
      avatarFilename: 'avatar-mytrip.png',
      headerColor: vars.colors.decoration.dark,
    };
  }

  return {
    uiBundle: 'oriana_ui_bundle',
    avatarFilename: 'avatar-neutral.png',
    headerColor: '#4D4D4D',
  };
};

export const getIframeSrcUrl = (
  uiBundle: string,
  emailId: string,
  orderNumber: string,
  domain: string,
  siteLanguageCode: string,
  iframeSrc: string,
  domainCode: string,
) => {
  return `${iframeSrc}${uiBundle}/chat?language=${siteLanguageCode}&domainCode=${domainCode}&data1=${emailId}&data2=${orderNumber}&data3=https://${domain}/rf/order-details`;
};

export const setOrianaChatOpen = () => {
  localStorage.setItem('isOrianaChatOpen', 'true');
};

export const setOrianaChatClosed = () => {
  localStorage.setItem('isOrianaChatOpen', 'false');
};
